module.exports = __webpack_public_path__ + "img/docx.70a4de8c.svg";